import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    globalReload: false,
    defaultSchedulerTab: 'app',
    defaultTimeFormat: {
      withoutSecond: 'hh:mm a',
      withSecons: 'hh:mm:ss a',
    },
  },
  reducers: {
    handleGlobalReload: (state, action) => {
      state.globalReload = action.payload;
    },
    defSchedTab: (state, action) => {
      state.defaultSchedulerTab = action.payload;
    },
    defTimeFormate: (state, action) => {
      state.defaultTimeFormat = action.payload;
    },
  },
});

export const { handleGlobalReload, defSchedTab, defTimeFormate } =
  appSlice.actions;
export default appSlice.reducer;
